import React from 'react'
import Link from 'next/link'

// @ts-ignore
import { home } from '../routes'
import styles from './NotFound.module.css'
import RawFormattedMessage from './RawFormattedMessage'
import { Link as LinkType } from '../../types/Link'

type NotFoundProps = {
  goBackLink?: LinkType
  keyPrefix?: string
}

export default function NotFound ({
  keyPrefix = 'shared',
  goBackLink = home()
}: NotFoundProps) {
  return (
    <section className={styles.root}>
      <header>
        <RawFormattedMessage tagName='h4' id={`${keyPrefix}.not-found`} />
      </header>
      <Link {...goBackLink}>
        <a>
          <RawFormattedMessage id={`${keyPrefix}.back-to-list`} />
        </a>
      </Link>
    </section>
  )
}
